<template>
  <div class="mt-4">
    <div class="row qlikVar-row mb-4">
        <div class="col-12 col-md-12">
          <QlikViz vizId="KeapC" noHeader="true" class="noBorder" />
        </div>
      </div>

      <div class="row kpi-row">
        <div class="col-12 col-sm-3 col-md-3 col-lg-2">
          <QlikViz vizId="gPxTKm" noHeader="true" class="noBorder noPadding" />
        </div>
        <div class="col-12 col-sm-3 col-md-3 col-lg-2">
          <QlikViz vizId="BbLCDJ" noHeader="true" class="noBorder noPadding" />
        </div>
        <div class="col-12 col-sm-3 col-md-3 col-lg-2">
          <QlikViz vizId="esstWrK" noHeader="true" class="noBorder noPadding" />
        </div>
        <div class="col-12 col-sm-3 col-md-3 col-lg-2">
          <QlikViz vizId="SsemCz" noHeader="true" class="noBorder noPadding" />
        </div>
      </div>

      <div class="row row-object one-viz-row mt-4">
        <div class="col-12 col-md-6">
          <QlikViz
            vizId="KAhxkwr"
            class="noPadding qlik_container"
          />
        </div>
        <div class="col-12 col-md-6">
          <QlikViz
            vizId="qmaahJN"
            class="noPadding  qlik_container"
          />
        </div>
      </div>
  </div>
</template>
<script>

import QlikViz from "../../../../components/QlikViz"

export default {
  name: "UKI-SalesSummarySales",
  props: [],
  components: {
    QlikViz: QlikViz
  },
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      qObjects:"KeapC,gPxTKm,BbLCDJ,esstWrK,SsemCz,KAhxkwr,qmaahJN",
    };
  },
  async mounted() {
    this.$emit('sub-report-mounted', this.qObjects.split(","));
  },
  async destroyed() {
    this.$emit('sub-report-destroyed', this.qObjects.split(","));
  }
};
</script>